import gsap from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

/* select element */
function s(scope, attribute, child = false) {
	let elements = [];
	if (child) {
		elements = scope.querySelectorAll(attribute + " " + child);
	} else {
		elements = scope.querySelectorAll(attribute);
	}

	if (elements.length > 0) {
		return elements;
	} else {
		return false;
	}
}

export default function initAnimations() {
	gsap.registerPlugin(ScrollTrigger);

	let sections = document.querySelectorAll("[data-animate-container]");

	for (let i = 0; i < sections.length; i++) {
		let el = sections[i];

		let tl = gsap.timeline();

		// basic fade-in-up animation
		if (el.getAttribute("data-animate") == "fade-in-up") {
			let fadeInUpTl = gsap.timeline({
				paused: true,
				defaults: {
					y: "40",
					autoAlpha: 0,
					ease: "power1.out",
					duration: 0.8,
					stagger: 0.2,
				},
				scrollTrigger: {
					trigger: el,
					start: "top 80%",
					toggleActions: "play none none reverse",
					markers: false,
				},
			});
			tl = fadeInUpTl;

			let stagger = s(el, "[data-animate*='stagger']");
			if (stagger) {
				gsap.set(stagger, { clearProps: "all" });
			}
			if (stagger) {
				tl.from(stagger, {}, "start");
			} // do stagger animation (as defined in defaults)
		}

		// basic parallax animation
		let parallaxBg = s(el, "[data-animate*='parallax-bg']");
		if (parallaxBg) {
			gsap.to(parallaxBg, {
				backgroundPositionY: `calc(50% - ${innerHeight / 7}px)`,
				ease: "linear",
				y: 0,
				delay: 1.6,
				autoAlpha: 1,
				scrollTrigger: {
					trigger: el,
					scrub: 0.9,
				},
			});
		}

		let smoothScroll = s(el, "[data-animate*='smooth-scroll']");
		if (smoothScroll) {
			gsap.set(smoothScroll, { clearProps: "all" });
			gsap.fromTo(
				smoothScroll,
				{
					y: `${window.innerWidth / 90}px`,
				},
				{
					y: `${-window.innerWidth / 90}px`,
					ease: "linear",
					// stagger: true,
					scrollTrigger: {
						start: "top 60%",
						end: "bottom 40%",
						trigger: el,
						markers: false,
						scrub: 0.15,
						toggleActions: "play none none none",
					},
				}
			);
		}
	}
}
